const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const editorialSections = [
  '.cc-fabric',
  '.cc-brand',
  '.cc-details',
  '.cc-standard',
  '.cc-proof',
  '.cc-featured-campaign',
];

const prepareMotion = (root = document) => {
  if (reduceMotion || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('caddy-motion-ready');

  const targets = root.querySelectorAll(editorialSections.join(','));
  targets.forEach((section) => {
    section.setAttribute('data-caddy-reveal', '');
    section.querySelectorAll('.cc-fabric__media, .cc-brand__media, .cc-details__media, .cc-proof__media')
      .forEach((media) => media.setAttribute('data-caddy-image-reveal', ''));
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      entry.target.querySelectorAll('[data-caddy-image-reveal]').forEach((media) => media.classList.add('is-revealed'));
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });

  targets.forEach((target) => observer.observe(target));
};

const prepareColourStudies = (root = document) => {
  root.querySelectorAll('.cc-colour').forEach((section) => {
    const options = [...section.querySelectorAll('.cc-colour__option')];
    const selectable = options.filter((option) => option.querySelector('.cc-colour__option-visual'));
    if (!selectable.length) return;

    const select = (option) => {
      options.forEach((item) => item.removeAttribute('aria-current'));
      option.setAttribute('aria-current', 'true');
      const status = section.querySelector('[data-colour-status]');
      if (status) status.textContent = `${option.innerText.trim()} selected`;
    };

    select(selectable[0]);
    selectable.forEach((option) => {
      option.addEventListener('pointerenter', () => select(option));
      option.addEventListener('focus', () => select(option));
    });
  });
};

prepareMotion();
prepareColourStudies();

document.addEventListener('shopify:section:load', (event) => {
  prepareMotion(event.target);
  prepareColourStudies(event.target);
});
